<div
  class="presentation-overlay"
  [class.visible]="isVisible"
  [style.z-index]="ZIndex.FULLSCREEN"
>
  <!-- Loading State -->
  @if (!presentationReady) {
    <div class="presentation-loading">
      <p>
        {{
          "dashboard-presentation.message.preparing-presentation" | translate
        }}
      </p>
      <app-loading></app-loading>
    </div>
  }

  @if (presentationReady) {
    <div class="presentation-content">
      <div class="presentation-header">
        <div class="logo-container">
          @if (presentationSettings?.show_sensika_logo) {
            <img [src]="logoUrl" alt="Sensika Logo" />
          }
          <!-- TODO: Company logo implementation - not implemented yet in the app -->
          @if (presentationSettings?.show_company_logo) {
            <div></div>
          }
        </div>
        <div class="current-page-section">
          @if (presentationSettings?.dashboard_title_visible) {
            <h1
              class="presentation-title"
              [style.fontSize.px]="
                presentationSettings?.dashboard_title_font_size
              "
              [style.fontWeight]="
                presentationSettings?.dashboard_title_font_weight
              "
              [style.color]="
                getThemeColor(presentationSettings?.dashboard_title_color)
              "
            >
              {{ dashboard?.title }}
            </h1>
          }
          @if (presentationSettings?.page_title_visible) {
            <h2
              class="page-title"
              [style.fontSize.px]="presentationSettings?.page_title_font_size"
              [style.fontWeight]="presentationSettings?.page_title_font_weight"
              [style.color]="
                getThemeColor(presentationSettings?.page_title_color)
              "
            >
              {{ (slides$ | async)?.[currentSlideIndex]?.page.name }}
            </h2>
          }
          @if (
            presentationSettings?.time_period_visible &&
              (effectivePeriod$ | async);
            as p
          ) {
            <span
              class="period"
              [style.fontSize.px]="presentationSettings?.time_period_font_size"
              [style.fontWeight]="presentationSettings?.time_period_font_weight"
              [style.color]="
                getThemeColor(presentationSettings?.time_period_color)
              "
            >
              {{ p?.startTimestamp * 1000 | date: "dd.MM.yyyy HH:mm" }}
              –
              {{ p?.endTimestamp * 1000 | date: "dd.MM.yyyy HH:mm" }}
            </span>
          }
          <app-dashboard-auto-refresh-counter
            [secondsLeft]="autoReloadSecondsLeft$ | async"
            [cacheEnabled]="cacheEnabled$ | async"
            [reloading]="(widgetsReloading$ | async) ?? false"
          ></app-dashboard-auto-refresh-counter>
        </div>
        <div class="progress-section">
          @if (presentationSettings?.show_controls) {
            <div class="controls-section">
              @if (isAutoMode) {
                <fa-icon
                  [icon]="isPlaying ? faCirclePause : faCirclePlay"
                  (click)="togglePlayPause()"
                  [ngClass]="{ play: !isPlaying, pause: isPlaying }"
                ></fa-icon>
              }
              <fa-icon
                [icon]="faCircleStop"
                (click)="onStopClick()"
                class="stop"
              ></fa-icon>
            </div>
          }
          @if (presentationSettings?.pagination_visible) {
            <div
              class="pagination"
              [style.fontSize.px]="presentationSettings?.pagination_font_size"
              [style.fontWeight]="presentationSettings?.pagination_font_weight"
              [style.color]="
                getThemeColor(presentationSettings?.pagination_color)
              "
            >
              @if (slides$ | async; as slides) {
                {{ currentSlideIndex + 1 }} / {{ slides.length }}
              }
            </div>
          }
          @if (isAutoMode && showTimer) {
            <div
              class="autoplay-progress"
              [style.fontSize.px]="presentationSettings?.timer_font_size"
              [style.fontWeight]="presentationSettings?.timer_font_weight"
              [style.color]="getThemeColor(presentationSettings?.timer_color)"
            >
              <svg #progressSvg viewBox="0 0 48 48">
                <circle
                  cx="24"
                  cy="24"
                  r="20"
                  stroke-width="4"
                  stroke-dasharray="125.6"
                  stroke-dashoffset="125.6"
                  [attr.stroke]="
                    getThemeColor(presentationSettings?.timer_color)
                  "
                ></circle>
              </svg>
              <span>{{ remainingTime }}s</span>
            </div>
          }
        </div>
      </div>
      <div #slideContainer class="custom-carousel">
        <div
          class="slides-wrapper"
          [style.transform]="'translateX(' + slideOffset + 'px)'"
          [style.transition]="slideTransition"
        >
          @for (slide of slides$ | async; track trackBySlideId($index, slide)) {
            <div class="slide">
              <div class="slide-content">
                @if (slide.widgets.length > 0) {
                  <gridstack
                    [options]="presentationGridConfig"
                    class="slide-widgets"
                  >
                    @for (
                      widget of slide.widgets;
                      track trackByWidgetId($index, widget)
                    ) {
                      <gridstack-item [options]="getGridItemOptions(widget)">
                        <app-widget-card
                          [widget]="widget"
                          [editMode]="false"
                          [viewProperties]="viewProperties"
                          [presentationModeActive]="isVisible"
                          [showLoading]="false"
                        >
                        </app-widget-card>
                      </gridstack-item>
                    }
                  </gridstack>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
